import React, {Component} from 'react';
import {Link} from 'react-router-dom'

class ConfigurazioneMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div className="ui cards">

        <div className="card">
            <div className="content">
                <div className="header">Spostamento Attività</div>
                <div className="description">
                    dato un giorno iniziale, un utente e un giorno finale,
                    sposta se possibile tutte le attività dell'utente indicato nel giorno finale, se è libero.
                </div>
            </div>
            <div className="extra content center aligned">
                <Link to={"/app/configurazione/spostaattivita"} className="ui basic green button">Prosegui</Link>
            </div>
        </div>
        <div className="card">
            <div className="content">
                <div className="header">Comandi Server</div>
                <div className="description">
                    Esecuzione di script e/o applicazioni installati sul server. Devono essere pre-configurati sul server.
                </div>
            </div>
            <div className="extra content center aligned">
                <Link to={"/app/configurazione/comandiserver"} className="ui basic green button">Prosegui</Link>
            </div>
        </div>
        <div className="card">
            <div className="content">
                <div className="header">Gestione Utenti</div>
                <div className="description">
                    Creazione di nuovi utenti, modifica o cancellazione degli utenti attualmente presenti nel sistema.
                </div>
            </div>
            <div className="extra content center aligned">
                <Link to={"/app/utenti"} className="ui basic green button">Prosegui</Link>
            </div>
        </div>

    </div>)
  }
}

export default ConfigurazioneMenu;




/** WEBPACK FOOTER **
 ** ./src/components/configurazione/ConfigurazioneMenu.js
 **/